export default {"src":"/_next/static/media/local-file.2da3a771.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};